import type { Listing } from '@app/models'

import type { ListingAdvertiserType } from './types'

export const getListingAdvertiserType = (
  listing?: Listing | null
): ListingAdvertiserType | undefined => {
  if (!listing) {
    return undefined
  }

  const isPrivateListing = listing.relatedAccounts?.some(
    (account) => account.type === 'PrivateAdvertiser'
  )

  return isPrivateListing ? 'private' : 'professional'
}
